<template>
  <div class="content-container flex-column">
    <div class="grid-x toolbar fixed">
      <div class="cell auto">
        <h4 class="no-margin toolbar-title">EO-Faktura <small>({{state.info}})</small></h4>
      </div>
      <div class="cell shrink" v-if="bilag && bilag.Bilagsid">
        <span class="button-container has-popover" :class="{'popover-active': pdfPopoverActive}">
          <span class="button action glyph" @click="togglePdfPopover">
            <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-contract"></use></svg>
            <span>Vis faktura</span>
          </span>
          <span class="popover align-x-right align-y-bottom medium">
            <ul>
              <li><a href="javascript:;" @click="showBilagsPdf"><span>Vis strekkkode</span></a></li>
              <li><a href="javascript:;" @click="showBilagsEmailPdf"><span>Skriv ut / send e-post</span></a></li>
            </ul>
          </span>
        </span>
      </div>
      <div class="cell shrink" v-if="$store.getters.isFormSubmittable">
        <a href="javascript:;" @click="onKundeCancel()" class="button primary transparent">Lukk EO-Faktura</a>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormProcessing">
        <a href="javascript:;" class="button primary transparent">Lukk EO-Faktura</a>
        <a href="javascript:;" class="button primary loading">Lagrer...<span class="loader-spinner"></span></a>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormLoading">
        <a href="javascript:;" @click="onKundeCancel()" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" class="button primary" disabled>Lagre<span class="show-for-medium"> endringer</span></a>
      </div>
    </div>

    <div class="card large-padding margin-top no-margin-bottom">
      <TheLoader :active="loading" :small="true"/>

      <template v-if="!loading">
        <TheEmptyList v-if="!state.finished && !state.editableAs && !isReturnInvoice"
                      :title="'Ikke klar før fakturering...'" :large="false" :icon="'button-glyph-object'"/>
        <TheEmptyList v-else-if="!state.finished && !state.editableAs && isReturnInvoice" :title="'Fakturert retur...'"
                      :large="false" :icon="'button-glyph-object'"/>

        <template v-if="state.editableAs">
          <div class="grid-x">
            <!-- Popover -->
            <div class="cell auto">
              <span class="button-container has-popover" :class="{'popover-active': varePopoverActive}"
                    @click="toggleVarePopover()">
                <span class="button action glyph"><svg width="16px" height="16px" viewBox="0 0 16 16"><use
                  xlink:href="/static/sprites.svg#button-glyph-add"></use></svg> <span>Ny fakturalinje</span></span>
                <span class="popover align-x-left align-y-bottom xlarge">
                  <overlay-scrollbars
                    :options="{ className: 'custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
                  <ul>
                    <li v-for="item in vareOptions.sort(sortLinevalues).filter(x => x.status)" v-bind:key="'add-' + item.data.Vareid">
                      <a href="javascript:;" @click="addVare(item)" class="add-form-line popover-form-line"><span>{{item.data.Beskrivelse || item.val}} <span
                        class="label">{{item.val}}</span></span></a>
                    </li>
                  </ul>
                  </overlay-scrollbars>
                </span>
              </span>
            </div>
            <!-- // Popover -->

            <!-- The Form things -->
            <div class="cell shrink">
              <span class="button-container has-popover" :class="{'popover-active': formPopoverActive}"
                    @click="toggleFormPopover()">
                <span class="button action glyph"><svg width="16px" height="16px" viewBox="0 0 16 16"><use
                  xlink:href="/static/sprites.svg#button-glyph-edit"></use></svg> <span>Innstillinger</span></span>
                <span class="popover popover-has-footer align-x-right align-y-bottom medium">
                  <ul>
                    <li>
                      <TheSwitchInputPopover v-model="form.Export" label="Eksport" labelTrue="" labelFalse=""
                                             trueValue="T" falseValue="F"/>
                    </li>
                    <li :class="{'disabled': form.Export !== 'T'}">
                      <TheSwitchInputPopover v-model="form.Mvafri" label="Mvafri" labelTrue="" labelFalse=""
                                             trueValue="T" falseValue="F" :disabled="form.Export !== 'T'"/>
                    </li>
                  </ul>
                </span>
              </span>
            </div>
            <!-- // The Form things -->
          </div>
        </template>

        <table class="medium padding margin-top margin-bottom" v-if="state.finished || state.editableAs">
          <thead>
          <tr>
            <th>Beskrivelse</th>
            <th>Kode</th>
            <th class="align-right">Pris eks. mva</th>
            <th class="align-right">Pris inkl. mva</th>
            <th class="align-right">&nbsp;</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="line in bilagLines" v-bind:key="line.Internalid">
            <td>
              <span v-if="!state.editableAs">{{line.Beskrivelse | truncate(80)}}</span>
              <div v-else class="input-container minimal no-margin large text">
                <input type="text" v-model="line.Beskrivelse" maxlength="100">
                <span class="glyph"><svg viewBox="0 0 44 44"><use
                  xlink:href="/static/sprites.svg#button-glyph-pencil"></use></svg></span>
              </div>
            </td>
            <td>
              <span class="label">{{line.Varenr}}</span>
            </td>
            <td class="align-right opacity-60">
              {{line.Belop | thousandsFloat}}
            </td>
            <td class="align-right">
              <span v-if="!state.editableAs || !line.Internaledit">{{line.Beloptotal | thousandsFloat}}</span>
              <TheDecimalInputTable v-else v-model="line.Beloptotal"
                containerClassName="input-container minimal align-right no-margin small"
                @blur="onValueChange($event, line)"/>
            </td>

            <td class="align-right">
              <a href="javascript:;" v-if="state.editableAs && line.Internaldel" @click="delBilagLine(line)"
                 class="button action input-action glyph glyph-only no-margin">
                <svg width="16px" height="16px" viewBox="0 0 16 16">
                  <use xlink:href="/static/sprites.svg#button-glyph-delete"></use>
                </svg>
              </a>
            </td>
          </tr>
          </tbody>
          <tfoot class="highlight">
          <tr>
            <td colspan="2"><strong>Total</strong></td>
            <td class="align-right"><strong>{{totalPriceExc}}</strong></td>
            <td class="align-right"><strong>{{totalPriceInc}}</strong></td>
            <td>&nbsp;</td>
          </tr>
          </tfoot>
        </table>

        <div class="grid-x">
          <div class="cell auto"></div>

          <!-- Already Invoiced -->
          <div class="cell shrink" v-if="state.finished">
            <!-- Annuler -->
            <!-- Krediter -->
          </div>

          <!-- Normal invoice -->
          <div class="cell shrink" v-else-if="state.editableAs === 'normal'">
            <a v-if="!loading" href="javascript:;" class="button primary submit large" @click="openSaveModal()">Opprett
              faktura</a>
            <a v-if="loading" href="javascript:;" class="button primary submit large" disabled>Opprett faktura</a>
          </div>
        </div>
      </template>
    </div>

  </div>
</template>

<script>
import KundeCardForm from './KundeCardForm'
import InstillingerService from '@/services/InstillingerService'
import bus from '@/plugins/event-bus'
import accounting from 'accounting-js'

export default {
  name: 'EoFaktura',
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    KundeCardForm
  },
  props: {
    kunde: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      pdfPopoverActive: false,
      loading: true,
      bkh: false,
      processing: false,
      vareList: [],
      varePopoverActive: false,
      formPopoverActive: false,
      bilag: null,
      bilagLines: [],
      currentIndexCount: 0,
      isReturnInvoice: false,
      isInAuction: false,
      objektTitle: '',
      form: {
        Bilagstype: 'F',
        Retur: 'F',
        Export: 'F',
        Mvafri: 'F',
        objektdata: {
          Salgspris: 0,
          Auksjon: null
        },
        bilaglines: []
      }
    }
  },
  mounted () {
    bus.$on('invoice-created', (data) => this.onInvoiceCreated(data))
  },
  watch: {
    'form.Export': function (newVal) {
      if (newVal === 'F') {
        this.form.Mvafri = 'F'
      }
    },
    'form.Mvafri': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.recalcAll()
      }
    }
  },
  computed: {
    state: function () {
      if (this.bilag && this.bilag.Bilagsid) {
        return { finished: true, editableAs: null, info: 'Fakturert' }
      }
      return {finished: false, editableAs: 'normal', info: 'Ikke fakturert'}
    },
    vareOptions: function () {
      return this.vareList.filter((i) => {
        if (i.data.Varekode === 'OBJEKT') {
          return false
        }

        if (i.data.Varekode === 'BKH') {
          return false
        }

        return true
        // return !i.Used
      })
    },
    totalPriceInc: function () {
      let retval = 0

      this.bilagLines.forEach((line) => {
        if (line.Beloptotal !== null && line.Beloptotal !== '') {
          retval += parseFloat(line.Beloptotal)
        }
      })

      return accounting.formatNumber(retval, {precision: 2, thousand: ' '})
    },
    totalPriceExc: function () {
      let retval = 0

      this.bilagLines.forEach((line) => {
        if (line.Belop !== null && line.Belop !== '') {
          retval += parseFloat(line.Belop)
        }
      })

      return accounting.formatNumber(retval, {precision: 2, thousand: ' '})
    }
  },
  created () {
    bus.$off('invoice-created')

    var vm = this

    window.jQuery(document).mouseup(function (e) {
      var container = window.jQuery('.has-popover')

      if (!container.is(e.target) && container.has(e.target).length === 0) {
        vm.varePopoverActive = false
        vm.formPopoverActive = false
        vm.pdfPopoverActive = false
      }
    })

    this.loading = true
    this.processing = false

    this.setup()
    this.fetch()
  },
  methods: {
    showBilagsPdf: function () {
      this.pdfPopoverActive = false
      this.openModal('bilag-pdf-modal', {bilag: this.bilag, internalWindow: true}, 'split')
    },
    showBilagsEmailPdf: function () {
      this.pdfPopoverActive = false
      this.openModal('bilag-email-pdf-modal', { query: this.bilag, internalWindow: true }, 'split')
    },
    onInvoiceCreated: function (data) {
      this.$helpers.showSuccessAlert('Faktura er lagret')
      this.setBilag(data.bilag)
    },
    recalcAll: function () {
      this.bilagLines.forEach(line => {
        this.recalcLine(line, true)
      })
    },
    onValueChange: function ($event, line) {
      let index = this.bilagLines.findIndex(x => x.Internalid === line.Internalid)

      if (index === -1) {
        return
      }

      this.recalcLine(line)
      // if (Number(this.bilagLines[index].Pris) !== Number(line.Belop)) {
      //   this.recalcLine(line)
      // } else {
      //   let updated = {
      //     Belop: accounting.formatNumber(this.bilagLines[index].Belop, {precision: 2, thousand: ''})
      //   }
      //   this.$set(this.bilagLines, index, Object.assign({}, this.bilagLines[index], updated))
      // }
    },
    openSaveModal: function () {
      if (this.bilagLines.length === 0) {
        this.$helpers.showErrorAlert('Du må ha minst en bilagslinje.')
        return
      }
      this.openModal('eo-faktura-modal',
        {
          data: this.form,
          state: this.state,
          lines: this.bilagLines,
          mottaker: this.kunde,
          internalWindow: true
        },
        'split'
      )
    },
    setup: function () {
      this.isReturnInvoice = false
      this.isInAuction = false
    },
    fetch: function () {
      InstillingerService('vare').dropdownByParams({type: 'K'})
        .then((response) => {
          this.vareList = response.data.map(obj => ({...obj, Used: false}))
          this.loading = false
        })
        .catch((e) => {
          console.log(e)
        })
    },
    setBilag: function (data) {
      this.bilag = data
      this.bilagLines = []

      if (this.bilag.bilagslinje) {
        let index = -1

        this.bilag.bilagslinje.forEach((line) => {
          line.Internalid = line.Bilagslinjeid
          line.Internaltype = 'old'

          line.Beloptotal = accounting.formatNumber((line.Belop || 0) + (line.Mvabelop || 0), {precision: 2, thousand: ''})
          line.Pris = accounting.formatNumber(line.Pris || 0, {precision: 2, thousand: ''})
          line.Belop = accounting.formatNumber(line.Belop || 0, {precision: 2, thousand: ''})
          line.Mvagrunnlag = accounting.formatNumber(line.Belop || 0, {precision: 2, thousand: ''})
          line.Mvabelop = accounting.formatNumber(line.Mvabelop || 0, {precision: 2, thousand: ''})

          index = this.vareList.findIndex(x => x.data.Varekode === line.Varenr)
          if (index !== -1) {
            this.vareList[index].Used = true
          }

          this.addBilagLine(line)
        })
      }
    },
    addVare: function (item) {
      const index = this.vareList.findIndex(x => x.data.Vareid === item.data.Vareid)

      if (index === -1) {
        this.$helpers.showErrorAlert('Feil', 'Kunne ikke finne vare')
        return
      }

      const data = {
        Antall: 1,
        Pris: item.data.Pris ? parseFloat(item.data.Pris) : 0,
        Mvapct: this.form.Mvafri === 'F' && item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0,
        Varetype: 'V',
        Varenr: item.data.Varekode,
        Beskrivelse: item.data.Beskrivelse || item.data.Varekode,
        Internaldel: true,
        Internaledit: true
      }

      const line = this.makeVareLine(item, data)
      this.addBilagLine(line)
      this.vareList[index].Used = true
    },
    makeVareLine: function (vare, data, onlyRecalc) {
      let Pris = data.Pris || 0

      // const Belop = data.Antall * Pris
      // const Mvabelop = Belop * (this.form.Mvafri === 'F' && data.Mvapct ? (data.Mvapct / 100) : 0)

      if (!onlyRecalc) {
        if (this.form.Mvafri === 'F') {
          // if (!this.hasBKH() || vare.data.Mvakode !== 'BKH') {
          // eslint-disable-next-line
          if (Pris != 0 && vare.data.Prisinclmva === 'T' && data.Mvapct) {
            Pris = Pris / ((100 + parseInt(data.Mvapct)) / 100)
          }
          // }
        }
      } else {
        if (this.form.Mvafri === 'F') {
          // if (!this.hasBKH() || vare.data.Mvakode !== 'BKH') {
          // eslint-disable-next-line
          if (Pris != 0 && data.Mvapct) {
            Pris = Pris / ((100 + parseInt(data.Mvapct)) / 100)
          }
          // }
        }
      }

      let Mvabelop = 0
      let Belop = data.Antall * Pris

      if (onlyRecalc && data.Varenr === 'SALÆR') {
        Mvabelop = Belop * (data.Mvapct / 100)
      } else if (this.form.Mvafri === 'F' && data.Mvapct) {
        Mvabelop = Belop * (data.Mvapct / 100)
      }

      // const Mvabelop = Belop * (this.form.Mvafri === 'F' && data.Mvapct ? (data.Mvapct / 100) : 0)

      const Beloptotal = Belop + Mvabelop

      let line = {
        Antall: data.Antall,
        // Pris: accounting.formatNumber(Pris, {precision: 2, thousand: ''}),
        // Belop: accounting.formatNumber(Belop, {precision: 2, thousand: ''}),
        // Mvagrunnlag: accounting.formatNumber(Belop, {precision: 2, thousand: ''}),
        // Mvabelop: accounting.formatNumber(Mvabelop, {precision: 2, thousand: ''}),
        // Beloptotal: accounting.formatNumber(Belop + Mvabelop, {precision: 2, thousand: ''}),
        Pris: accounting.formatNumber(Pris, {precision: 2, thousand: ''}),
        Belop: accounting.formatNumber(Belop, {precision: 2, thousand: ''}),
        Mvagrunnlag: accounting.formatNumber(Belop, {precision: 2, thousand: ''}),
        Mvabelop: accounting.formatNumber(Mvabelop, {precision: 2, thousand: ''}),
        Beloptotal: accounting.formatNumber(Beloptotal, {precision: 2, thousand: ''}),

        Mvakode: this.form.Mvafri === 'F' ? vare.data.Mvakode : null,
        Mvapct: this.form.Mvafri === 'F' && data.Mvapct ? data.Mvapct : null,
        Mvatype: this.form.Mvafri === 'F' && vare.data.mva ? vare.data.mva.Mvatype : null,
        Beskrivelse: data.Beskrivelse,
        Bokforgruppekode: vare.data.bokforgruppe ? vare.data.bokforgruppe.Bokforgruppekode : '',
        Enhetskode: vare.data.Enhetskode,
        Vareid: vare.data.Vareid,
        Varenr: data.Varenr,
        Varetype: data.Varetype
      }

      if (!onlyRecalc) {
        line.Avgiftpct = null
        line.Bilagsid = null
        line.Bilagslinjeid = null
        line.Katalognr = null
        line.Linjenr = null
        line.Rabatbelop = null
        line.Rabatpct = null
        line.eurokurs = null
        line.Internalid = 'new-' + (this.currentIndexCount++)
        line.Internaltype = 'new'
        line.Internaldel = data.Internaldel
        line.Internaledit = data.Internaledit
      }

      return line
    },
    addBilagLine: function (item) {
      this.bilagLines.push(item)
    },
    delBilagLine: function (item) {
      let index = this.bilagLines.findIndex(x => x.Internalid === item.Internalid)

      if (index === -1) {
        return
      }

      this.bilagLines.splice(index, 1)

      if (item.Vareid) {
        index = this.vareList.findIndex(x => x.data.Vareid === item.Vareid)

        if (index !== -1) {
          this.vareList[index].Used = false
        }
      }
    },
    sortLinevalues: function (a, b) {
      let aText = a.data.Beskrivelse || a.val
      let bText = b.data.Beskrivelse || b.val
      return aText.localeCompare(bText)
    },
    recalcLine: function (currLine, mvaChanged) {
      let index = this.bilagLines.findIndex(x => x.Internalid === currLine.Internalid)

      if (index !== -1) {
        const vidx = this.vareList.findIndex(x => x.data.Varekode === currLine.Varenr)
        const item = this.vareList[vidx]

        let Pris = 0
        if (mvaChanged) {
          // Must recalc to exclude mva
          if (this.form.Mvafri === 'F' && item.data.mva && item.data.mva.Mvapct) {
            Pris = currLine.Pris * ((100 + parseInt(item.data.mva.Mvapct)) / 100)
          } else {
            Pris = currLine.Pris
          }
        } else {
          Pris = parseFloat(currLine.Beloptotal || 0)
        }

        const line = this.makeVareLine(item, {
          Antall: 1,
          Pris: Pris,
          Mvapct: this.form.Mvafri === 'F' && item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0,
          Varetype: 'V',
          Varenr: item.data.Varekode,
          Beskrivelse: this.bilagLines[index].Beskrivelse || item.data.Beskrivelse,
          Internaldel: true,
          Internaledit: true
        }, true)

        this.$set(this.bilagLines, index, Object.assign({}, this.bilagLines[index], line))
      }
    },
    toggleVarePopover: function () {
      this.varePopoverActive = !this.varePopoverActive
      this.formPopoverActive = false
      this.pdfPopoverActive = false
    },
    toggleFormPopover: function () {
      this.formPopoverActive = !this.formPopoverActive
      this.varePopoverActive = false
      this.pdfPopoverActive = false
    },
    togglePdfPopover: function () {
      this.pdfPopoverActive = !this.pdfPopoverActive
      this.formPopoverActive = false
      this.varePopoverActive = false
    },
    onKundeCancel: function () {
      this.$emit('switchKundeView', false)
    },
    onSaveButtonClick: function () {
      bus.$emit('kunde-form-submit')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/EoFaktura.vue